import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { IUser } from 'modules/core/types';

export interface ILogContext {
  [key: string]: unknown;
}

export const getUserLogContext = (user: IUser | null | undefined): ILogContext => ({
  user: user?.email,
  session_tracking_id: user?.sessionTrackingId || '',
  is_sso: user?.is_sso || false,
  with_inventory: user?.isWithInventory || false,
  tenant_subdomain: user?.tenant?.subdomain,
  url_path: window.location.pathname,
  sso_type: user?.sso_type || '',
  deal_source: user?.dealSource || '',
});

export const logToDatadog = (message: string, context?: ILogContext, user?: IUser | null): void => {
  const userContext = getUserLogContext(user);

  datadogLogs.logger.info(message, { ...userContext, ...context });
};

export const setUserAttributes = (user: IUser | null): void => {
  datadogRum.setUser({
    id: user?.email || 'anonymous',
    email: user?.email,
    name: `${user?.firstName} ${user?.lastName}`,
    role: user?.role,
    session_tracking_id: user?.sessionTrackingId || '',
    is_sso: user?.is_sso || false,
    with_inventory: user?.isWithInventory || false,
    tenant_subdomain: user?.tenant?.subdomain,
    first_name: user?.firstName,
    last_name: user?.lastName,
    phone_number: user?.phoneNumber,
    url_path: window.location.pathname,
    sso_type: user?.sso_type || '',
    deal_source: user?.dealSource || '',
  });
};

export const startSessionReplay = (user: IUser | null): void => {
  setUserAttributes(user);
  datadogRum.startSessionReplayRecording();
};
